// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._47XRI .jjtqD+.jjtqD{margin-top:16px}@media screen and (min-width:768px){._47XRI .jjtqD+.jjtqD{margin-top:40px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "_47XRI",
	"slider": "jjtqD"
};
module.exports = ___CSS_LOADER_EXPORT___;
